export default "__VITE_ASSET__CYw12jru__"